import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import kn from './locales/kn.json';
import en from './locales/en.json';

// Get saved language preference from localStorage, default to Kannada
const getSavedLanguage = () => {
  if (typeof window !== 'undefined') {
    const savedLang = localStorage.getItem('language');
    if (savedLang && (savedLang === 'kn' || savedLang === 'en')) {
      return savedLang;
    }
  }
  return 'kn'; // Default to Kannada
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      kn: { translation: kn },
      en: { translation: en },
    },
    lng: getSavedLanguage(), // Load saved preference or default to Kannada
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;